import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Permission
import { HasPermission } from "Core/security"

//Actions
import {
    clearRedux,
    notesGetNoteRequest,
    notesCreateRequest,
    notesUpdateRequest,
} from 'Redux/actions';


//Styles
import './index.scss';

const CreateEditNote = (props) => {
    const { tableRef, deviceId } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef();

    const {
        openModal,
        loading,
        create,
        update,
        noteEdit,
        currentId
    } = useSelector(state => state.createEditNoteRedux);
    const user = useSelector(state => state.securityRedux.user);

    const [note, setNote] = useState("");
    const [id, setId] = useState(null);
    const [show, setShow] = useState(false);

    const closeModal = () => {
        setNote("");
        dispatch(clearRedux("NOTES_CREATE_EDIT"));
        setId(null);
        setShow(false);
    }

    const applyChanges = () => {
        const trimmedNote = (note || '').trim();
        if (!trimmedNote) {
            NotificationManager.error(
                messages['required_field'],
                messages['notes_note'],
                3000
            );
            return;
        }

        let payload = {
            projectId: "PM",
            entityName: "Unit",
            entityId: `${deviceId}`,
            note: trimmedNote
        }
        if (!id) {
            dispatch(notesCreateRequest(payload))
        } else {
            payload.id = id;
            dispatch(notesUpdateRequest(payload));
        }
    }


    useEffect(() => {
        if (create?.id) {
            NotificationManager.success(
                messages['notes_create_success_message'],
                messages['notes_create_new_note'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("NOTES_CREATE_EDIT", { create: null }))
        }
        if (update?.id) {
            NotificationManager.success(
                messages['notes_update_success_message'],
                messages['notes_create_edit_note'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("NOTES_CREATE_EDIT", { update: null }))
        }
        if (noteEdit) {
            setNote(noteEdit?.note || '');
            setId(noteEdit?.id);
            setShow(noteEdit?.show)
            dispatch(clearRedux("NOTES_CREATE_EDIT", { noteEdit: null }))
        }
        if (currentId) {
            dispatch(notesGetNoteRequest(currentId))
            dispatch(clearRedux("NOTES_CREATE_EDIT", { currentId: null }))
        }
    }, [create, update, noteEdit, currentId])

    return (
        <Modal
            open={openModal}
            title={!show ? !id ? messages['notes_create_new_note'] : messages['notes_create_edit_note'] : messages['notes_create_show_note']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => {
                            applyChanges()
                        }}
                    >
                        <div style={{ marginTop: 5 }}>
                            <Input
                                type="textarea"
                                label={messages['notes_note']}
                                placeholder={messages['notes_note']}
                                value={note}
                                onChange={(value) => setNote(value)}
                                maxLength={2000}
                                minLength={3}
                                required
                                requiredMessage={messages['required_field']}
                                minLengthMessage={messages['notes_min_length']}
                                minMessage={messages['required_field']}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                {
                    !show && (HasPermission(user, "note", "c") || HasPermission(user, "note", "u")) &&
                    <Button
                        className="btn-dark-blue"
                        onClick={() => {
                            formRef?.current?.submit()
                        }}
                    >
                        {messages['save']}
                    </Button>
                }
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditNote;